// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"5ec476f1","213":"be346853","337":"7f28dc30","455":"1119f041","512":"5d69d2b1","585":"abdd5815","735":"a9aa40ac","836":"942da3a2","840":"a9e1d199","857":"9185ec2d","885":"9e60b6ad","890":"9278266b"}[chunkId] + ".chunk.js";
};